module.exports = __webpack_public_path__ + "static/hero-24721a81c823cb7594bbb0c075c2598a.svg";